import React from 'react';
import { Box, Flex, Loader, Text, Tooltip } from '@marvelapp/ui';
import { getEditableTextBg } from './utils';
export default function SectionName(_a) {
    var canRename = _a.canRename, editableName = _a.editableName, isCollapsed = _a.isCollapsed, isHighlighted = _a.isHighlighted, isLoading = _a.isLoading, sectionName = _a.sectionName, sectionNameId = _a.sectionNameId;
    if (canRename && !isLoading) {
        return (React.createElement(Wrap, { isCollapsed: isCollapsed, isHighlighted: isHighlighted }, editableName));
    }
    return (React.createElement(Wrap, { isCollapsed: isCollapsed, isHighlighted: isHighlighted },
        React.createElement(Flex, { alignItems: "center" },
            React.createElement(Text, { color: "licorice", cursor: "default", "data-testid": "section-name", fontSize: 4, fontWeight: 500, id: sectionNameId, lineHeight: "29px", marginRight: 3, truncated: false }, sectionName),
            isLoading && (React.createElement(Tooltip, { content: "This section is in read-only mode until created", cursor: "default" },
                React.createElement(Loader, { borderWidth: 2 }))))));
}
function Wrap(_a) {
    var children = _a.children, isHighlighted = _a.isHighlighted, isCollapsed = _a.isCollapsed;
    return (React.createElement(Box, { bg: getEditableTextBg({ isHighlighted: isHighlighted, isCollapsed: isCollapsed }), paddingRight: 10, transition: "none" }, children));
}
